import { css, type Component } from "dreamland/core";
import { logout } from "../api";
import { router } from "dreamland/router";

const Settings: Component<{}, {}> = function (cx) {
	return (
		<div class="page">
			<h1>Settings</h1>
            <p>it's too early to have any settings...</p>
            <button type="submit" class="primary" on:click={async()=>{
                await logout();
                router.navigate("/");
            }}>
                        <span class="material-symbols-sharp">logout</span>
                        Log Out
                </button>
            <div class="about">
                <p>tar v{__APP_VERSION__} ({__COMMIT_HASH__})</p>
                <p>built {__BUILD_DATE__}</p>
            </div>
		</div>
	);
};

Settings.style = css`
    .about {
        margin-top: 2rem;
        font-size: 0.8em;
        color: #555;
    }
`

export default Settings;